module.exports = new __parcel__URL__("vitalik-vynarchyk-0PePaKnEmuM-unsplash.7b13d974.jpg").toString();